import SidebarToggle_vue_vue_type_script_setup_true_lang_default from "./SidebarToggle.vue.script.js";
//#region src/v2/components/sidebar/SidebarToggle.vue
var SidebarToggle_default = SidebarToggle_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { SidebarToggle_default as default };

//# sourceMappingURL=SidebarToggle.vue.js.map